





























import { Prop, Component, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { ReferralStats } from '@/api/model/referral-stats'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')
import { percentage } from '@/plugins/filters-string'
import { PipelinePhaseCategory, ReferralCount, ReferralStatus } from '@/api/types'

@Component
export default class PipelineTabPhase extends Vue {
    @Prop({ required: true }) readonly pipeline!: Pipeline
    @Prop({ required: true }) readonly phase!: PipelinePhase
    @Prop() readonly status!: ReferralStatus
    @referrals.State readonly referralStats!: ReferralStats
    @referrals.State readonly phaseFilter!: PipelinePhase
    @referrals.State readonly referralCounts!: ReferralCount
    @referrals.State readonly statusFilter!: string
    @referrals.State readonly pipelineFilter!: string
    @referrals.State readonly phaseCategoryFilter!: PipelinePhaseCategory
    @referrals.Action applyPipelinePhaseFilter!: ({ phase: PipelinePhase }) => Promise<void>

    get title(): string {
        return this.phase.name
    }

    get count(): number {
        return this.referralStats.countForPhase(this.phase.id)
    }

    get countBackgroundColor(): string {
        return this.phase.color
    }

    get countColor(): string {
        return 'white'
    }

    get active(): boolean {
        return this.phase.id === this.phaseFilter?.id
    }

    activate(): void {
        this.applyPipelinePhaseFilter({
            phase: this.phase,
        })
    }

    get canViewPotentialOrderValue(): boolean {
        return this.pipeline.canViewPotentialOrderValue(this.$currentUser)
    }

    get potentialOrderValue(): number {
        return this.referralStats.potentialOrderValueForPhase(this.phase.id)
    }

    get expectedOrderValue(): number {
        return this.potentialOrderValue * this.pipeline.conversionPercentage / 100
    }

    get expectedOrderValueTooltipContent(): string {
        return this.$t('referral-list.expectedOrderValue-tooltip', {
            conversionPercentage: percentage(this.pipeline.conversionPercentage / 100, 2),
        }).toString()
    }
}
